import React from 'react'
import './footer.css'
import { Link } from 'react-router-dom';

const Footer = () => {
	return (
		<div className="footer">
			<div className="container">
				<div className="row">
					<div className="col-lg-12">
						<p className='copyright'>
							© 2025 <Link to="/">Daaw.</Link> All Rights Reserved | Developed
							by <span>Abhinaw </span> (+91 9006605034)
						</p>
					</div>
				</div>
			</div>
		</div>
	);
} 

export default Footer